import api from './axios';
import { authHeader, noContentTypeHeader } from '../helpers';
import { authService } from './authentication.service';

export const rapportsService = {
    getArborescenceBySurv,
    getArborescenceOMRBySurv,
    getPath,
    getRapportGeneralDataById,
    getRapportVariableDataById,
    getRapportAbonnementDataById,
    getRapportHistoryDataById,
    getListeFichiersModeles,
    getListeModeles,
    getModeleGeneralDataById,
    getModeleHistoryDataById,
    getModeleRapportsLies,
    getFichierRapportGenere,
    getLienFichierModele,
    getFichierModele,
    getFrequenceData,
    getRapportsGeneresDataById,
    addAbonnement,
    removeAbonnement,
    createModele,
    insertFichierModele,
    createRapport,
    updateModele,
    updateModeleLocation,
    updateRapport,
    updateRapportLocation,
    updatePublicationData,
    updateVariableMapping,
    uploadFichierModele,
    activerModele,
    desactiverModele,
    activerRapport,
    desactiverRapport,
    deleteModele,
    deleteRapport,
    deleteRapportGenere,
    generationManuelle,
    isOMRNameAlreadyTaken
};

async function getArborescenceBySurv(id_surv) {
    return api.get(`/Rapports/arborescence/${id_surv}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getArborescenceOMRBySurv(id_surv) {
    return api.get(`/Rapports/arborescenceOmr/${id_surv}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getPath(id_element) {
    return api.get(`/Rapports/getPath/${id_element}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getRapportGeneralDataById(id_rapport) {
    return api.get(`/Rapports/${id_rapport}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getRapportVariableDataById(id_rapport) {
    return api.get(`/Rapports/${id_rapport}/variables`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getRapportAbonnementDataById(id_rapport) {
    return api.get(`/Rapports/${id_rapport}/abonnements`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getRapportHistoryDataById(id_rapport) {
    return api.get(`/Rapports/${id_rapport}/historique`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getListeFichiersModeles() {
    return api.get('/Modeles/fichiers/list', {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getListeModeles() {
    return api.get('/Modeles/list', {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getModeleGeneralDataById(id_modele) {
    return api.get(`/Modeles/${id_modele}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getModeleHistoryDataById(id_modele) {
    return api.get(`/Modeles/${id_modele}/historique`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getModeleRapportsLies(id_modele) {
    return api.get(`/Modeles/${id_modele}/rapports_lies`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getFrequenceData() {
    return api.get('/Rapports/frequence', {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getRapportsGeneresDataById(id_rapport) {
    return api.get(`/Rapports/${id_rapport}/rapports_generes`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function addAbonnement(id_rapport, id_utilisateurs) {
    const payload = {
        idRapport: id_rapport,
        userEmails: id_utilisateurs
    };

    return api.post('/Rapports/abonnements', payload, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function removeAbonnement(id_rapport, id_utilisateur) {
    const payload = {
        idRapport: id_rapport,
        userEmails: id_utilisateur
    };

    return api.delete('/Rapports/abonnements', {
        headers: authHeader(),
        data: payload
    })
        .then(authService.handleResponse);
}

async function getFichierRapportGenere(id_job_generation) {
    return api.get(`/Rapports/rapport_genere/${id_job_generation}`, {
        headers: authHeader(),
        responseType: 'blob'
    })
        .then(response => {
            const contentDisposition = response.headers['content-disposition'];
            const filename = contentDisposition.match(/filename="?(.+?)"?;/i)[1];

            const blob = response.data;
            const a = document.createElement('a');
            a.style.display = 'none';

            if (window.navigator.msSaveOrOpenBlob) {
                a.onclick = () => {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                };
            } else {
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = filename;
            }

            document.body.appendChild(a);
            a.click();
            if (!window.navigator.msSaveOrOpenBlob) {
                window.URL.revokeObjectURL(a.href);
            }
            a.remove();

            return response.data;
        })
        .catch(error => {
            if (error.response && error.response.data) {
                return Promise.reject(error.response.data);
            }
            return Promise.reject(error);
        });
}

function getLienFichierModele(id_fichier) {
    return `/Modeles/fichier/${id_fichier}`;
}

async function getFichierModele(id_fichier) {
    return api.get(`/Modeles/fichier/${id_fichier}`, {
        headers: authHeader(),
        responseType: 'blob'
    })
        .then(response => {
            const contentDisposition = response.headers['content-disposition'];
            const filename = contentDisposition.match(/filename=(.+);/i)[1];

            const blob = response.data;
            const a = document.createElement('a');
            a.style.display = 'none';

            if (window.navigator.msSaveOrOpenBlob) {
                a.onclick = () => {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                };
            } else {
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = filename;
            }

            document.body.appendChild(a);
            a.click();
            if (!window.navigator.msSaveOrOpenBlob) {
                window.URL.revokeObjectURL(a.href);
            }
            a.remove();

            return response.data;
        })
        .catch(error => {
            if (error.response && error.response.data) {
                return Promise.reject(error.response.data);
            }
            return Promise.reject(error);
        });
}

async function uploadFichierModele(fichier) {
    const formData = new FormData();
    formData.append('fichier_excel', fichier);

    return api.post('/Modeles/fichier', formData, {
        headers: noContentTypeHeader(fichier.name)
    })
        .then(authService.handleResponse);
}

async function createModele(payload) {
    return api.post('/Modeles', payload, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function insertFichierModele(id_modele, modele_payload) {
    return api.post(`/Modeles/${id_modele}/file`, modele_payload, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function createRapport(payload) {
    return api.post('/Rapports', payload, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function updateModele(id_modele, modele) {
    const payload = {
        Actif: modele.actif,
        Libelle: modele.libelleModele,
        Description: modele.descriptionModele,
        IdFichierModele: modele.idFichier
    };

    return api.patch(`/Modeles/update/${id_modele}`, payload, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function updateModeleLocation(id_modele, payload) {
    return api.patch(`/Modeles/${id_modele}/location`, payload, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function updateRapport(id_rapport, payload) {
    return api.patch(`/Rapports/${id_rapport}`, payload, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function updateRapportLocation(id_rapport, payload) {
    return api.patch(`/Rapports/${id_rapport}/location`, payload, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function updatePublicationData(id_rapport, payload) {
    return api.patch(`/Rapports/${id_rapport}/publication`, payload, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function updateVariableMapping(payload) {
    return api.post('/Rapports/variables', payload, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function activerModele(id_modele) {
    return api.patch('/Modeles/etat', { Id: id_modele, Value: true }, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function desactiverModele(id_modele) {
    return api.patch('/Modeles/etat', { Id: id_modele, Value: false }, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function activerRapport(id_rapport) {
    return api.patch('/Rapports/etat', { Id: id_rapport, Value: true }, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function desactiverRapport(id_rapport) {
    return api.patch('/Rapports/etat', { Id: id_rapport, Value: false }, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function deleteModele(id_modele) {
    return api.delete(`/Modeles/${id_modele}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function deleteRapport(id_rapport) {
    return api.delete(`/Rapports/${id_rapport}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function deleteRapportGenere(id_job) {
    return api.delete(`/Rapports/rapports_generes/${id_job}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function generationManuelle(payload) {
    return api.post('/Rapports/generer', payload, {
        headers: authHeader(),
        responseType: 'blob'
    })
        .then(response => {
            const contentDisposition = response.headers['content-disposition'];
            const filename = contentDisposition.match(/filename="(.+?)"/i)[1].replace(/"/g, '');

            const blob = response.data;
            const a = document.createElement('a');
            a.style.display = 'none';

            if (window.navigator.msSaveOrOpenBlob) {
                a.onclick = () => {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                };
            } else {
                const url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = filename;
            }

            document.body.appendChild(a);
            a.click();
            if (!window.navigator.msSaveOrOpenBlob) {
                window.URL.revokeObjectURL(a.href);
            }
            a.remove();

            return response.data;
        })
        .catch(error => {
            if (error.response && error.response.data) {
                return Promise.reject(error.response.data);
            }
            return Promise.reject(error);
        });
}

async function isOMRNameAlreadyTaken(nom_rapport) {
    return api.get(`/Rapports/isOMRNameAlreadyTaken?nomRapport=${nom_rapport}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}
